import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import config from "config";
import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

interface LinkProps {
	href?: string;
	className?: string;
	selected?: boolean;
	Icon?: ReactNode;
	children?: ReactNode;
	primaryText?: string;
	secondaryText?: string;
	submenuId?: string;
	'data-test-id'?: string;
	'data-folder-id'?: string | number;
	onClick?: (e: React.MouseEvent) => void;
}

export function Link(props: LinkProps) {
	const renderIcon = () => {
		const { Icon } = props;
		if (!Icon) {
			return null;
		}

		return <ListItemIcon>{Icon}</ListItemIcon>;
	};

	return (
		<ListItemButton
			className={props.className}
			selected={
				props.selected === undefined && props.href
					? top.location.pathname.slice(config.URL_PREFIX.length) === props.href
					: props.selected
			}
			component={props.href ? RouterLink : "div"}
			to={props.href ? props.href : undefined}
			onClick={props.onClick}
			data-test-id={props['data-test-id']}
			data-folder-id={props['data-folder-id']}
		>
			{renderIcon()}
			<ListItemText
				primary={props.children || props.primaryText}
				secondary={props.secondaryText}
			/>
		</ListItemButton>
	);
}
